<template lang="pug">
  span.icon
    component(:is="iconComponent" :class="disabled ? `${name}_disabled` : undefined" aria-hidden="true")
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import AccountIcon from '@/assets/images/account.svg?component'
import BurgerIcon from '@/assets/images/burger.svg?component'
import ChevronIcon from '@/assets/images/chevron.svg?component'
import CloseIcon from '@/assets/images/close.svg?component'
import HomeIcon from '@/assets/images/home.svg?component'
import SearchIcon from '@/assets/images/search.svg?component'

const icons = {
  account: AccountIcon,
  burger: BurgerIcon,
  chevron: ChevronIcon,
  close: CloseIcon,
  home: HomeIcon,
  search: SearchIcon,
} satisfies Record<string, Component>

type IconName = keyof typeof icons

const props = withDefaults(
  defineProps<{
    name: IconName
    disabled?: boolean
  }>(),
  { disabled: false },
)

const iconComponent = computed(() => icons[props.name])
</script>
